import { Fx, Icon } from 'Components';
import Heading from '../../../NewDashboard/components/Heading';
import styles from './HeaderRow.module.scss';

type Props = {
    title?: string,
    subHeading?: string,
    parentClass?: string,
    icon?: React.ReactNode;
    children?: React.ReactNode;
}

const HeaderRow = ({ title = "", subHeading = "", parentClass = "", children = null, icon = null }: Props) => {
    return <Fx align="middle" justify="space-between" className={`${styles.root} ${parentClass}`}>
        <Heading {...{ title, subHeading, icon }} titleClassName={styles.pageTitle} subTitleClassName={styles.pageSubTitle} />
        {children}
    </Fx>
}

export default HeaderRow;
